import { inject, Injectable } from '@angular/core';
import { HeaderAction } from '@docpath/webcomponents';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class PageHeaderActionsService {
    private readonly translateService = inject(TranslateService);

    updateSearchStyle(rightActions: HeaderAction[], filtersCount: number, actionName = 'search'): void {
        const searchAction = this.getSearchAction(rightActions, actionName);

        if (searchAction) {
            const actionTooltip = searchAction.tooltip ?? '',
                baseLabel = actionTooltip.replace('.tooltip', '');

            let labelSuffix = 'label',
                labelParameters = {},
                cssClass = 'btn-dpsecondary';

            if (filtersCount > 0) {
                labelSuffix = 'label-filtered';
                labelParameters = { count: filtersCount };
                cssClass = 'btn-dpsky';
            }

            const translatedLabel = this.translateService.instant(`${baseLabel}.${labelSuffix}`, labelParameters);

            searchAction.title = translatedLabel;
            searchAction.customStyles = { cssClass };
        }
    }

    private getSearchAction(rightActions: HeaderAction[], actionName: string): HeaderAction | undefined {
        return rightActions.find(action => action.tooltip?.endsWith(`.${actionName}.tooltip`));
    }
}
